<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { PageHeader, Button } from '@drama/ui'

import StoryFilmNotificationPreview from '../components/story-film/StoryFilmNotificationPreview.vue'

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <div class="story-film-notification-preview vga-page" data-insp-path="apps/visual-game-admin/src/pages/StoryFilmNotificationPreview.vue">
    <PageHeader :title="t('visualGameAdmin.storyFilmPromptReview.simulatedPage.title')">
      <template #subtitle>
        <span>{{ t('visualGameAdmin.storyFilmPromptReview.simulatedPage.subtitle') }}</span>
      </template>
    </PageHeader>
    <div class="snp-gate">
      <p class="snp-warning">{{ t('visualGameAdmin.storyFilmPromptReview.simulatedPage.isolation') }}</p>
      <Button size="sm" variant="ghost" @click="router.push('/story-film/prompt-review')">
        {{ t('visualGameAdmin.storyFilmPromptReview.simulatedPage.back') }}
      </Button>
    </div>
    <StoryFilmNotificationPreview />
  </div>
</template>

<style scoped>
.snp-gate { display: flex; flex-wrap: wrap; gap: 12px; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.snp-warning { font-size: 12px; color: var(--drama-color-warning, var(--drama-color-text-muted)); margin: 0; }
</style>
